
import { Component, namespace, Vue } from 'nuxt-property-decorator'
import GoogleRating from '~/components/widgets/GoogleRating.vue'
import PhoneNumberLink from '~/components/snippets/PhoneNumberLink.vue'
import { getExternalIndexHref } from '~/utils/external-links.utils'

@Component({
  components: {
    GoogleRating,
    PhoneNumberLink,
  },
})
export default class PartnerFooter extends Vue {
  private readonly currentYear = (new Date()).getFullYear()

  get externalIndexHref (): string {
    return getExternalIndexHref(this.$config.BASE_URL, this.localePath)
  }
}
